import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ProtectedRoute = () => {
  const [authState, setAuthState] = useState({ checked: false, allowed: false });

  useEffect(() => {
    const check = async () => {
      // Opción 1: sesión activa en localStorage (mismo navegador, mismo equipo)
      const localStaff = localStorage.getItem('gdt_active_staff');
      if (localStaff) {
        setAuthState({ checked: true, allowed: true });
        return;
      }

      // Opción 2: sesión activa en sessionStorage (abrió una pestaña nueva en el mismo equipo)
      const sessionStaff = sessionStorage.getItem('gdt_active_staff');
      if (sessionStaff) {
        // Sincronizamos al localStorage para que funcione normalmente
        localStorage.setItem('gdt_active_staff', sessionStaff);
        const sessionUser = sessionStorage.getItem('gdt_active_user');
        if (sessionUser) localStorage.setItem('gdt_active_user', sessionUser);
        setAuthState({ checked: true, allowed: true });
        return;
      }

      // Opción 3: sesión activa de Supabase Auth (otro navegador / otra computadora)
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        // El usuario tiene sesión Supabase válida. Buscamos su perfil en professionals
        const email = session.user?.email || '';
        const username = email.replace('@gestionamientodeturnos.com', '');

        const { data: professionals } = await supabase
          .from('professionals')
          .select('*');

        if (professionals) {
          // Buscamos el profesional cuyo array `users` contenga el username
          const matchedStaff = professionals.find(p =>
            Array.isArray(p.users) && p.users.some(u => u.username?.toLowerCase() === username.toLowerCase())
          );

          if (matchedStaff) {
            const matchedUser = matchedStaff.users.find(u => u.username?.toLowerCase() === username.toLowerCase());
            localStorage.setItem('gdt_active_staff', JSON.stringify(matchedStaff));
            localStorage.setItem('gdt_active_user', JSON.stringify(matchedUser));
            setAuthState({ checked: true, allowed: true });
            return;
          }
        }
      }

      // Sin sesión válida → redirigir al login
      localStorage.removeItem('gdt_active_staff');
      localStorage.removeItem('gdt_active_user');
      setAuthState({ checked: true, allowed: false });
    };

    check();

    // Escuchamos cambios de sesión de Supabase en tiempo real
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        const local = localStorage.getItem('gdt_active_staff');
        if (!local) {
          setAuthState({ checked: true, allowed: false });
        }
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (!authState.checked) {
    return (
      <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', color: 'var(--text-light)' }}>
        Verificando sesión segura...
      </div>
    );
  }

  if (!authState.allowed) {
    return <Navigate to="/login/staff" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
